export const fillColors = theme => [
  theme.palette.quaternary.main,
  theme.palette.tertiary.main,
  theme.palette.primary.main,
  theme.palette.secondary.main
]

export const temporaryDataPopup = {
  title: "Novas Atualizações no Sistema!",
  subtitle: "Confira as novidades",
  items: [
    {
      description:
        "Agora você pode filtrar imóveis por proximidade a escolas, hospitais e outros"
    },
    {
      description:
        "Novo relatório mensal de visitas disponíveis para cada propriedade."
    },
    {
      description:
        "Ajustes na segurança para proteger melhor as informações dos clientes."
    }
  ]
}

export const PremiumPages = [
  "/painel/academy",
  "/painel/suporte",
  "/painel/imoveis/networks"
]
